import { Injectable } from '@angular/core';
import { API_ENDPOINT } from '@core/configs';
import { CreateHelpRequestModel } from '@core/models/request/help.model';
import { ApiService } from '../common/api.service';
import { formatDateToString } from '@core/helper';
import { DeleteSupportStaffRequestModel, InviteSupportStaffRequestModel } from '@core/models/request';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private readonly http: ApiService) {
  }

  checkUserByEMail(params: any[]) {
    return this.http.get(API_ENDPOINT.user.controller + API_ENDPOINT.user.checkUserByEMail, params);
  }

  getSupportStaffsByCustId(params: any[]) {
    return this.http.get(API_ENDPOINT.user.controller + API_ENDPOINT.user.getSupportStaffsByCustId, params);
  }


  inviteSupportStaff(data: InviteSupportStaffRequestModel) {
    return this.http.post(
      API_ENDPOINT.user.controller + API_ENDPOINT.user.inviteSupportStaff,
      data,
    );
  }

  deleteSupportStaff(data: DeleteSupportStaffRequestModel) {
    return this.http.post(
      API_ENDPOINT.user.controller + API_ENDPOINT.user.deleteSupportStaff,
      data,
    );
  }

}
